function newWkoList(){
    $wkoList = function(){};
    $wkoListObject = null;
    $wkoListOption = {
        current_page: 1,
        listItemIds:{},
        listItemAjax: "",
        listLimit: 10,
        listLimitAjax: "",
        addToUrlHistoryText: "",
        maxPage: 0,
    };
    $paginator = null;
    $pageLimiter = null;
    $amountWithPageElement = null;
    $amountWithOutPageElement = null;
    $gesTextElement = null;
    $gesTextElement = null;
    $fromTextElement = null;
    $toTextElement = null;
    $pagerElement = null;
    $pagerPagesElement = null;
    $katetorieCssClass = "";
    $katetorieContent = "";
    $addToAjax = "";

    $wkoList.init = function($listHtmlObj){
        window.addEventListener("popstate", function(e) {
            document.location = document.location;
        });

        $wkoListObject = $listHtmlObj;
        $wkoList.showPage($wkoListOption.current_page, true);

        if($pageLimiter != null){
            $pageLimiter.on("change", function(e){
                e.preventDefault();
                var listLimit = parseInt($(this).find("option:selected").val());
                $wkoList.setListLimit(listLimit);
                $pageLimiter.find("option").prop("selected", false);
                $pageLimiter.find("option[value='"+listLimit+"']").prop("selected", true);
                $wkoList.refresh();
                if($wkoListOption.listLimitAjax != ""){
                    $.ajax({
                        url:$wkoListOption.listLimitAjax,
                        data:{limit:listLimit,
                              csrf_token:csrf_token
                        },
                        type:"POST"
                    }).done(function(errors){});
                }
            })
        }
    }

    $wkoList.setListLimit = function(elemenCount){
        $wkoListOption.maxPage = Math.ceil($wkoListOption.listItemIds.length/elemenCount)

        $wkoListOption.listLimit = elemenCount;
    }

    $wkoList.setListLimitAjax = function(ajaxUrl){
        $wkoListOption.listLimitAjax = ajaxUrl;
    }

    $wkoList.setListItemIds = function(ids){
        $wkoListOption.maxPage = Math.ceil(ids.length/$wkoListOption.listLimit)
        $wkoListOption.listItemIds = ids;
    }

    $wkoList.setListItemAjax = function(ajaxUrl){
        $wkoListOption.listItemAjax = ajaxUrl;
    }

    $wkoList.setCurrentPage = function(currentPage){
        $wkoListOption.current_page = parseInt(currentPage);
    }

    $wkoList.addToUrlHistory = function(key, param){
        $wkoListOption.addToUrlHistoryText += "&" + key + "=" + encodeURIComponent(param);
    }

    $wkoList.showPage = function(activePage, firstInit){
        showLoader();
        if(activePage > $wkoListOption.maxPage) activePage = $wkoListOption.maxPage;
        $wkoListOption.current_page = activePage;

        var ids = [];
        $.each($wkoListOption.listItemIds, function(key, id){
            if(($wkoListOption.listLimit * activePage - 1) >= key
                && ($wkoListOption.listLimit * (activePage - 1) - 1) < key){
                ids.push(id);
            }
        })

        $wkoList.updateAmount(activePage);
        $wkoList.updatePaginator(activePage);

        $.ajax({
            url:$wkoListOption.listItemAjax,
            data:{ids:ids,z:$addToAjax, csrf_token: csrf_token},
            type:"POST"
        }).done(function(html){
            $wkoListObject.html(html);
            if($katetorieCssClass != "" && $katetorieContent != ""){
                $(document).find("."+$katetorieCssClass).html($katetorieContent);
            }

            $('.js-list_gallery').each(function(){ // the containers for all your galleries
                $(this).magnificPopup({
                    delegate:'a', // the selector for gallery item
                    type:'image',
                    gallery:{
                        enabled:true,
                    }
                });
            });

            if(!firstInit){
                history.pushState({p:activePage}, "p " + activePage, '?p='+activePage + $wkoListOption.addToUrlHistoryText);
                window.scrollTo(0, 0);
            }
            hideLoader();
        });
    }

    $wkoList.updatePaginator = function(activePage){
        if($pagerElement != null && $pagerPagesElement != null){
            $pagerElement.html("");

            var maxPages = $wkoListOption.maxPage
            var endPage = Math.min(maxPages, activePage + 2)
            var startPage = Math.max(1, activePage - 2)

            // arrow left
            if(activePage != 1 && maxPages > 1){
                var $element = $pagerPagesElement.clone(true);
                $element.data("page", activePage-1).attr("href", "?p=" + activePage-1).attr('aria-label',aria_label_seite_zurueck).html("<i class=\"far fa-angle-left\"></i>");
                $element.addClass($element.attr("class") + "-icon")
                $pagerElement.append($element);
            }

            // erste page ab page 4
            if(activePage >= 4 && maxPages > 5){
                var $element = $pagerPagesElement.clone(true);
                $element.data("page", 1).attr("href", "?p=" + 1).text(1);
                $pagerElement.append($element);
            }

            // platzhalter zur ersten page ab page 5
            if(activePage >= 5 && maxPages > 5){
                var $element = $pagerPagesElement.clone();
                $element.text("-");
                $pagerElement.append($element);
            }

            // main
            for(count = startPage; count <= endPage; count++){
                var $element = $pagerPagesElement.clone(true);

                if(activePage == count){
                    $element.addClass($element.attr("class") + "-active")
                }
                $element.data("page", count).attr("href", "?p=" + count).text(count);
                $pagerElement.append($element);
            }

            // platzhalter zur letzten page
            if(activePage + 4 <= maxPages){
                var $element = $pagerPagesElement.clone();
                $element.text("-");
                $pagerElement.append($element);
            }

            // letzte page anzeigen
            if(activePage + 3 <= maxPages){
                var $element = $pagerPagesElement.clone(true);
                $element.data("page", maxPages).attr("href", "?p=" + maxPages).text(maxPages);
                $pagerElement.append($element);
            }

            // arrow right
            if(activePage != maxPages && maxPages > 1){
                var $element = $pagerPagesElement.clone(true);
                $element.data("page", activePage+1).attr("href", "?p=" + activePage+1).attr('aria-label',aria_label_naechtste_seite).html("<i class=\"far fa-angle-right\"></i>");
                $element.addClass($element.attr("class") + "-icon")
                $pagerElement.append($element);
            }
        }
    }

    $wkoList.updateAmount = function(activePage){
        var maxPages = $wkoListOption.maxPage

        if($gesTextElement != null){
            $gesTextElement.text($wkoListOption.listItemIds.length);
        }
        if($fromTextElement != null){
            $fromTextElement.text($wkoListOption.listLimit * (activePage - 1) + 1);
        }
        if($toTextElement != null){
            $toTextElement.text(Math.min($wkoListOption.listLimit * activePage, $wkoListOption.listItemIds.length));
        }

        if(maxPages > 1 && $amountWithPageElement != null){
            if($amountWithOutPageElement != null) $amountWithOutPageElement.hide();
            $amountWithPageElement.show();
        }else if($amountWithOutPageElement != null){
            if($amountWithPageElement != null) $amountWithPageElement.hide();
            $amountWithOutPageElement.show();
        }
    }

    $wkoList.refresh = function(){
        $wkoList.showPage($wkoListOption.current_page, false);
    }

    $wkoList.setGesCon = function($element){
        $gesTextElement = $element;
    }

    $wkoList.setFromCon = function($element){
        $fromTextElement = $element;
    }

    $wkoList.setToCon = function($element){
        $toTextElement = $element;
    }

    $wkoList.setPageLimiter = function($element){
        $pageLimiter = $element;
    }

    $wkoList.setPagerElement = function($element){
        $pagerElement = $element;
    }

    $wkoList.setAmountWithPageElement = function($element){
        $amountWithPageElement = $element;
    }

    $wkoList.setAmountWithOutPageElement = function($element){
        $amountWithOutPageElement = $element;
    }

    $wkoList.setPagerPagesElement = function($element){
        $element.on("click", function(e){
            e.preventDefault();
            if($(this).data("page") != $wkoListOption.current_page)$wkoList.showPage($(this).data("page"), false);
        })
        $pagerPagesElement = $element;
    }

    $wkoList.setKatetorieClass = function(CssClass){
        $katetorieCssClass = CssClass;
    }

    $wkoList.setKatetorieContent = function($content){
        $katetorieContent = $content;
    }

    $wkoList.addToAjax = function(value){
        $addToAjax = value;
    }

    return $wkoList;
}
